(function() {
    'use strict';

    angular
        .module('nasracApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
